export enum BigRadioButtonNameEnum {
    all = 'all',
    withAnswer = 'with-answer',
    withoutAnswer = 'without-answer',
}
